package ir.hosen.resume.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.styles.ButtonStyle
import ir.hosen.resume.util.FooterLinks
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.bps
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Img

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier.fillMaxWidth().height(30.vh).background(Theme.backgroundSurface),
        contentAlignment = Alignment.Center
    ) {

        Box(
            modifier = Modifier.fillMaxWidth().height(10.vh).align(Alignment.TopCenter).backgroundImage(
                linearGradient(
                    dir = LinearGradient.Direction.ToBottom, from = Theme.backgroundColor, to = Colors.Transparent
                )
            )
        )

        Column(
            modifier = Modifier.width(80.vw),
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.spacedBy(32.px)
        ) {
            SpanText(
                modifier = Modifier.color(Colors.Gray).fontFamily(Res.String.ROBOTO_REGULAR).fontSize(14.bps()),
                text = "Feel free to reach out to me via mail or any of the listed mediums"
            )
            Box(modifier = Modifier.fillMaxWidth()) {
                Row(
                    horizontalArrangement = Arrangement.spacedBy(16.px), verticalAlignment = Alignment.CenterVertically
                ) {
                    Button(
                        modifier = ButtonStyle.toModifier().background(Theme.onBackgroundColor),
                        size = ButtonSize.LG,
                        onClick = {
                            window.open(Res.Url.MY_EMAIL)
                        }) {
                        SpanText(
                            modifier = Modifier.color(Theme.backgroundColor).fontFamily(Res.String.ROBOTO_REGULAR)
                                .fontSize(18.bps()), text = "Email"
                        )
                    }

                    A(
                        href = "https://drive.google.com/file/d/1QwGqhJ410NThDErkP1BuDtjrFBNGlMRK/view?usp=drive_link",
                        attrs = LinkStyle.toModifier().color(Theme.onBackgroundColor).toAttrs()
                    ) {
                        SpanText(
                            modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_REGULAR)
                                .fontSize(18.bps()), text = "Resume."
                        )
                    }
                }

                Row(
                    modifier = Modifier.align(Alignment.CenterEnd),
                    horizontalArrangement = Arrangement.spacedBy(16.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FooterLinks.entries.forEach { item ->
                        Img(src = item.icon, attrs = FooterIconStyle.toModifier().onClick {
                            window.open(item.url)
                        }.filter(invert(if (Theme.isDark) 0 else 1)).toAttrs())
                    }
                }
            }
        }

    }
}